import { Component } from '@angular/core';

@Component({
  selector: 'app-saving',
  standalone: false,
  templateUrl: './saving.component.html',
  styleUrl: './saving.component.scss'
})
export class SavingComponent {

}
